module.exports = __webpack_public_path__ + "static/media/RU_SIG_NJAES_864x338.18565697.png";